import { measureLatency } from '../../../gctl-measure';
import {
  ClipcommentreactionFields,
  Clipcommentreaction,
} from '../../../models/components/schemas/clipcommentreaction/Clipcommentreaction';
import {
  Select,
  NetworkError,
  deepCamelCase,
  deepSnakeCase,
  searchQueryString,
  intoSnakeCase,
} from '../../../fetchers/_helpers';

/**
 * This file was automatically generated by @gctl/openapi-fetchers
 * Do not modify this file, any changes will be destroyed when
 * the command is rerun.
 */

export type PostVideoPrivateCommentReactionsFields = readonly ClipcommentreactionFields[];

/** Options for POST /videos/{video_id}/private_comments/{comment_id}/reactions */
export type PostVideoPrivateCommentReactionsOptions<Paths extends readonly string[]> = Omit<
  RequestInit,
  'method' | 'body'
> & {
  baseUrl?: string;

  /** Available fields on the response type, application/json */
  select: Paths;
  where: {
    /**
     * The ID of the video.
     */
    videoId: number;
    /**
     * The ID of the comment.
     */
    commentId: number;
  };

  /** Possible query parameters for /videos/{video_id}/private_comments/{comment_id}/reactions */
  query?: {
    /**
     * The password for the review link.
     */
    password?: string;

    /**
     * The ID of the review link used as context.
     */
    reviewId?: string;
  };

  /** Data serialized to body for POST /videos/{video_id}/private_comments/{comment_id}/reactions */
  variables?: {
    /**
     * The reaction to apply to the comment.
     *
     * Option descriptions:
     *  * `completed` - The reaction is a completed checkbox emoji.
     *  * `eyes` - The reaction is an eyes emoji.
     *  * `heart` - The reaction is a heart emoji.
     *  * `heavy_plus_sign` - The reaction is a heavy plus sign emoji.
     *  * `rocket` - The reaction is a rocket emoji.
     *  * `tada` - The reaction is a party popper emoji.
     *  * `thumbsdown` - The reaction is a thumbs-down emoji.
     *  * `thumbsup` - The reaction is a thumbs-up emoji.
     *
     * @example heart
     */

    reactionCode?:
      | `completed`
      | `eyes`
      | `heart`
      | `heavy_plus_sign`
      | `rocket`
      | `tada`
      | `thumbsdown`
      | `thumbsup`;
  };
};

/** Result type for POST /videos/{video_id}/private_comments/{comment_id}/reactions */
export type PostVideoPrivateCommentReactionsResult<Paths extends readonly string[]> = Select<
  Clipcommentreaction,
  Paths
>;

/**
 * Create a clip comment reaction
 * This method creates a clip comment reaction.
 */
export async function postVideoPrivateCommentReactions<
  Paths extends PostVideoPrivateCommentReactionsFields,
>({
  baseUrl,
  select,
  variables,
  where: { videoId, commentId },
  query,
  ...options
}: PostVideoPrivateCommentReactionsOptions<Paths>): Promise<
  PostVideoPrivateCommentReactionsResult<Paths>
> {
  return measureLatency('postVideoPrivateCommentReactions', 'POST', async () => {
    let res = await fetch(
      `${baseUrl}/videos/${videoId}/private_comments/${commentId}/reactions?${searchQueryString(
        query,
      )}&fields=${select.map(intoSnakeCase).join(',')}`,
      {
        ...options,
        method: 'POST',
        body: JSON.stringify(deepSnakeCase(variables)),
      },
    );

    if (!res.ok) {
      throw new NetworkError('A network error occurred', res.status, res);
    }

    if (res.status === 204) {
      return null as unknown as PostVideoPrivateCommentReactionsResult<Paths>;
    }

    if (!res.headers.get('content-type')?.match(/^application\/(.+)?json$/)) {
      throw new Error('Expected JSON response');
    }

    let json = await res.json();
    return deepCamelCase(json);
  });
}
